import { teams } from "@/data/athlete";
import { SectionHeader } from "./_shared";
import { Mail, Phone } from "lucide-react";

export const TeamCoach = () => {
  return (
    <section
      id="team"
      data-testid="team-section"
      className="border-t border-zinc-900 py-16 md:py-24"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <SectionHeader
          eyebrow="03 — Programs"
          title="Team & Coach Info"
          kicker="High school and club program affiliations with direct coach contact for verification."
          testId="team-header"
        />

        <div className="grid md:grid-cols-2 gap-4 md:gap-5">
          {teams.map((t) => (
            <div
              key={t.type}
              data-testid={`team-card-${t.type.toLowerCase().replace(/\s+/g, "-")}`}
              className="bg-[#141414] border border-zinc-800 p-6 md:p-8"
            >
              <div className="text-xs uppercase tracking-[0.3em] font-bold text-[#FF3B30] mb-3">
                {t.type}
              </div>
              <div className="font-display text-3xl text-white uppercase tracking-tight leading-tight">
                {t.program}
              </div>
              <div className="text-sm text-zinc-400 mt-2">{t.role}</div>

              <div className="my-6 h-px bg-zinc-800" />

              <div className="space-y-2">
                <div className="text-xs uppercase tracking-[0.25em] font-bold text-zinc-500">
                  Head Coach
                </div>
                <div className="text-white font-bold text-lg">
                  {t.coachName}
                </div>
                <div className="text-sm text-zinc-400">{t.coachTitle}</div>

                <div className="flex flex-col sm:flex-row gap-3 sm:gap-6 pt-3">
                  {t.coachEmail.includes("@") ? (
                    <a
                      data-testid={`coach-email-${t.type.toLowerCase()}`}
                      href={`mailto:${t.coachEmail}`}
                      className="flex items-center gap-2 text-sm text-zinc-300 hover:text-[#FF3B30] transition-colors break-all"
                    >
                      <Mail className="h-4 w-4 shrink-0" />
                      {t.coachEmail}
                    </a>
                  ) : (
                    <span
                      data-testid={`coach-email-${t.type.toLowerCase()}`}
                      className="flex items-center gap-2 text-sm text-zinc-500 italic"
                    >
                      <Mail className="h-4 w-4 shrink-0" />
                      {t.coachEmail}
                    </span>
                  )}
                  {(() => {
                    const digits = t.coachPhone.replace(/[^0-9]/g, "");
                    return digits.length >= 7 ? (
                      <a
                        data-testid={`coach-phone-${t.type.toLowerCase()}`}
                        href={`tel:${digits}`}
                        className="flex items-center gap-2 text-sm text-zinc-300 hover:text-[#FF3B30] transition-colors"
                      >
                        <Phone className="h-4 w-4 shrink-0" />
                        {t.coachPhone}
                      </a>
                    ) : (
                      <span
                        data-testid={`coach-phone-${t.type.toLowerCase()}`}
                        className="flex items-center gap-2 text-sm text-zinc-500 italic"
                      >
                        <Phone className="h-4 w-4 shrink-0" />
                        {t.coachPhone}
                      </span>
                    );
                  })()}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
